// Traduction française

const fr = {
  "hotel.folio": "Folios",
  "hotel.folio.registration_state": "État d’enregistrement",
  "hotel.folio.room": "Chambre",
  "hotel.folio.main_guest": "Client principal",
  "hotel.folio.nights_quantity": "Nuits",
  "hotel.folio.arrival_date": "Date d’arrivée",
  "hotel.folio.departure_date": "Date de départ",
  "hotel.folio.notes": "Notes",
  "hotel.folio.breakfast_included": "Petit-déjeuner inclus",
  "hotel.folio.check_in": "Arrivée",
  "hotel.folio.check_out": "Départ",
  "hotel.folio.reverse_checkout": "Annuler le départ",
  "hotel.folio.confirm": "Confirmer",
  "hotel.folio.pending": "En attente",
  "hotel.folio.booking": "Réservation",
  "hotel.folio.contact": "Contact",
  "hotel.folio.registration_card": "Fiche d’enregistrement",
  "hotel.folio.product": "Service",
  "hotel.folio.unit_price": "Prix unitaire",
  "hotel.folio.channel": "Canal",
  "hotel.folio.group": "Groupe",
  "hotel.folio.total_amount": "Montant total",
  "hotel.folio.bed_breakfast": "Chambre & petit-déjeuner",
  "hotel.folio.no_breakfast": "Sans petit-déjeuner",
  "hotel.folio.all_inclusive": "Tout compris",
  "hotel.folio.full_american": "Pension complète",
  "hotel.folio.half_american": "Demi-pension",
  "hotel.folio.num_adults": "Nombre d’adultes",
  "hotel.folio.num_children": "Nombre d’enfants",
  "hotel.folio.number": "Numéro",
  "hotel.folio.pax": "PAX",
  "hotel.folio.charge.folio": "Folio",
  "hotel.folio.charge.order": "Commande",
  "hotel.folio.charge.kind": "Type",
  "hotel.folio.charge.invoice_line": "Facture",
  "hotel.folio.charge.draft": "Brouillon",
  "hotel.folio.occupancy": "Occupation",
  "hotel.folio.occupancy.occupancy_date": "Date",
  "hotel.folio.occupancy.unit_price": "Prix unitaire",
  "hotel.folio.occupancy.unit_price_w_tax": "Prix unitaire TTC",
  "hotel.folio.occupancy.charge": "Frais",
  "hotel.folio.occupancy.state": "État",
  "hotel.folio.occupancy.draft": "Brouillon",
  "hotel.folio.occupancy.confirmed": "Confirmé",
  "hotel.folio.occupancy.invoiced": "Facturé",
  "hotel.folio.guest.city": "Ville",
  "sale.line.unit_price_w_tax": "Prix + taxe",
};

export default fr;
